define(function(require, exports, module) {
    var isLoginModel = {
        isLogin: function(data, success, error) {
            $.ajax({
                url: "//passport.jd.com/new/helloService.ashx",
                timeout: 20000,
                method: 'get',
                dataType: 'jsonp',
                success: function(data) {
                    if ($.isFunction(success)) {
                        var da = true;
                        if (data.info.indexOf("login()") < 0) {
                            da = true;
                        } else {
                            da = false;
                        }
                        success(da);
                    }
                }
            });
        }
    };
    module.exports = isLoginModel;
});



// WEBPACK FOOTER //
// ./src/js/model/isLogin/isLogin.js